/**
 * Created by Allan on 2022/04/09.
 * Contact 84880528@qq.com.
 * 判断当前value是否添加上升或下降样式
 */
export default function(value){
    if(!value) return '';
    let text=value.slice(0,1);
    return text==='+'?'up':(text==='-'?'down':'')
}



// WEBPACK FOOTER //
// ./src/filter/isActive.js